import { useEffect } from "react";

const SEQ = [
  "ArrowUp", "ArrowUp",
  "ArrowDown", "ArrowDown",
  "ArrowLeft", "ArrowRight",
  "ArrowLeft", "ArrowRight",
  "b", "a",
];

/**
 * Listens for the Konami code (↑ ↑ ↓ ↓ ← → ← → B A) and toggles a
 * `data-gravity-mode="true"` flag on the studio root. The atmosphere
 * canvas + black hole listen for the `parabolum:gravity-mode` event to
 * boost their effects.
 */
export default function GravityMode() {
  useEffect(() => {
    let idx = 0;
    const onKey = (e) => {
      const expected = SEQ[idx];
      if (!expected) return;
      const key = expected.startsWith("Arrow") ? e.key : e.key.toLowerCase();
      if (key === expected) {
        idx += 1;
        if (idx === SEQ.length) {
          idx = 0;
          const root = document.querySelector(".studio-root");
          if (!root) return;
          const on = root.dataset.gravityMode !== "true";
          root.dataset.gravityMode = on ? "true" : "false";
          window.dispatchEvent(new CustomEvent("parabolum:gravity-mode", { detail: { on } }));
          // brief on-screen acknowledgement
          const toast = document.createElement("div");
          toast.textContent = on ? "GRAVITY MODE — ON" : "GRAVITY MODE — OFF";
          toast.style.cssText = `
            position:fixed;left:50%;bottom:48px;transform:translateX(-50%);
            padding:10px 18px;border-radius:999px;
            background:rgba(228,255,0,0.92);color:#050505;
            font:600 11px/1 Manrope,system-ui,sans-serif;letter-spacing:.22em;
            text-transform:uppercase;z-index:9999;
            box-shadow:0 0 0 1px rgba(0,0,0,.2),0 16px 40px -10px rgba(228,255,0,.4);
            opacity:0;transition:opacity .35s ease, transform .35s ease;
          `;
          document.body.appendChild(toast);
          requestAnimationFrame(() => {
            toast.style.opacity = "1";
            toast.style.transform = "translateX(-50%) translateY(-4px)";
          });
          setTimeout(() => {
            toast.style.opacity = "0";
            setTimeout(() => toast.remove(), 400);
          }, 1800);
        }
      } else {
        idx = key === SEQ[0] ? 1 : 0;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return null;
}
